import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './header/header.component';
import { IntroPageComponent } from './intro-page/intro-page.component';
import { QuestionsComponent } from './questions/questions.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { SurveyClosedComponent } from './survey-closed/survey-closed.component';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { MaterialModule } from './material.module';
import { QuestionService } from 'src/services/question.service';
import { HttpClientModule } from '@angular/common/http';
import { SharedDataService } from 'src/services/shared-data.service';
import { OrganizationService } from 'src/services/organization.service';
import { LaunchService } from 'src/services/launch.service';
import { ResponseService } from 'src/services/response.service';
import { RespondentService } from 'src/services/respondent.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './http-interceptors/auth-interceptor';
import { RadioButtonVerticalComponent } from './questions/radio-button-vertical/radio-button-vertical.component';
import { FilterSectionPipe, ReplacePatientTermPipe } from './questions/filter-section.pipe';
import { FormsModule } from '@angular/forms';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; 
import { MomentModule } from 'ngx-moment';
import { FooterComponent } from './footer/footer.component';
import { QuestionsService } from './questions/questions.service';
import { ErrorPageComponent } from './error-page/error-page.component';

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,     
    SurveyClosedComponent,
    FooterComponent    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,    
    BrowserAnimationsModule,
    IntroPageComponent,
    QuestionsComponent,
    RadioButtonVerticalComponent,
    ThankYouComponent,
    HeaderComponent,
    SharedModule,
    CoreModule,
    MaterialModule,
    HttpClientModule,
    CommonModule,
    FilterSectionPipe,
    ReplacePatientTermPipe,
    FormsModule,
    NgIdleKeepaliveModule.forRoot(),
    MomentModule
  ],
  providers: [
    QuestionService,
    SharedDataService,
    OrganizationService,
    LaunchService,
    ResponseService,
    RespondentService,
    QuestionsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
